import { useEffect, useState } from "react";
import Logo from "../../images/Globalmages/logo.svg";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setScrollPosition } from "../../store/slices/scrollSlice";
import {
  HeaderBlock,
  HeaderContainer,
  HeaderContent,
  HeaderNav,
  LangMenu,
  LinkStyle,
  PopUpMenus,
} from "./HeaderStyles";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  AdditionalTitlesI,
  HeaderMenuI,
} from "../../interfaces/HeaderInterface";
import { LayoutGroup, motion } from "framer-motion";
import { ActiveLine } from "../ActiveLine/Activeline";
import { setCurrentRoute, setSecRoute } from "../../store/slices/routerSlice";
import { useTranslation } from "react-i18next";
import { setLocale } from "../../store/slices/localeSlice";
import i18n from "../../i18n";
import { generateLink } from "../../functions/routingFuntion";

export const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const scrollPosition = useAppSelector((state) => state.scroll.scrollPosition);
  const { currentRoute } = useAppSelector((state) => state.router);
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const titles: Array<HeaderMenuI> = [
    {
      title: t("header.arraysInfo11"),
      additionalTitles: [],
      route: "/terms",
    },
    {
      title: t("header.arraysInfo12"),
      additionalTitles: [],
      route: "/market",
    },
    {
      title: t("header.arraysInfo13"),
      additionalTitles: [
        {
          additionalTitle: t("header.arraysInfo21"),
          route: "/trade",
        },
        {
          additionalTitle: t("header.arraysInfo22"),
          route: "/trade/fundamentals",
        },
        {
          additionalTitle: t("header.arraysInfo23"),
          route: "/trade/analysis",
        },
        {
          additionalTitle: t("header.arraysInfo24"),
          route: "/trade/tehnical-analysis",
        },
        {
          additionalTitle: t("header.arraysInfo25"),
          route: "/trade/faq",
        },
      ],
      route: "/trade",
    },
    {
      title: t("header.arraysInfo14"),
      additionalTitles: [],
      route: "/about-us",
    },
    {
      title: t("header.arraysInfo15"),
      additionalTitles: [],
      route: "/contacts",
    },
  ];

  const handleScroll = () => {
    const position = window.scrollY;
    dispatch(setScrollPosition(position));
  };

  const changeLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = event.target.value;
    const currentPath = location.pathname;
    const pathWithoutLang = currentPath.replace(/^\/(en|de|fr)/, "");
    const updatedPath =
      newLang === "en"
        ? pathWithoutLang || "/"
        : `/${newLang}${pathWithoutLang}`;

    dispatch(setLocale(newLang));
    i18n.changeLanguage(newLang);
    navigate(updatedPath, { replace: true });
    dispatch(setCurrentRoute(updatedPath));
  };

  const closeNav = () => {
    setShowMenu(false);
  };

  const createMenu = (titles: Array<HeaderMenuI>, currentRoute: string) => {
    const cleanCurrentRoute = currentRoute.replace(/^\/(en|de|fr)/, "");

    return (
      <>
        {titles.map((title: HeaderMenuI) => {
          const cleanTitleRoute = title.route.replace(/^\/(en|de|fr)/, "");

          return (
            <motion.li className="main__list" key={title.title}>
              <LinkStyle
                to={generateLink(title.route, language)}
                currentRoute={cleanCurrentRoute}
                titleRoute={cleanTitleRoute}
                className="main__title"
              >
                {title.title}
              </LinkStyle>
              {cleanCurrentRoute === cleanTitleRoute && <ActiveLine />}{" "}
              {title.additionalTitles.length ? (
                <PopUpMenus className="popup__menus__anim">
                  <p>{title.title}</p>
                  {title.additionalTitles.map((item: AdditionalTitlesI) => {
                    const cleanItemRoute = item.route.replace(
                      /^\/(en|de|fr)/,
                      ""
                    );
                    return (
                      <li key={item.additionalTitle}>
                        <LinkStyle
                          to={generateLink(item.route, language)}
                          currentRoute={cleanCurrentRoute}
                          titleRoute={cleanItemRoute}
                          className="second__title"
                        >
                          {item.additionalTitle}
                        </LinkStyle>
                      </li>
                    );
                  })}
                </PopUpMenus>
              ) : null}
            </motion.li>
          );
        })}
      </>
    );
  };

  useEffect(() => {
    const pathWithoutLang = location.pathname.replace(/^\/(en|de|fr)/, "");

    if (
      titles[2].additionalTitles.some((item) => item.route === pathWithoutLang)
    ) {
      dispatch(setCurrentRoute("/trade"));
    } else {
      dispatch(setCurrentRoute(pathWithoutLang));
    }

    dispatch(setSecRoute(pathWithoutLang));
  }, [location.pathname, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      titles[2].additionalTitles.some(
        (item) => item.route === location.pathname
      )
    ) {
      dispatch(setCurrentRoute("/trade"));
    } else {
      dispatch(setCurrentRoute(location.pathname));
    }
    dispatch(setSecRoute(location.pathname));
  }, [currentRoute, dispatch, location]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (showMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showMenu]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <HeaderBlock scrollPos={scrollPosition}>
      <HeaderContainer className="container__standart">
        <HeaderContent>
          <NavLink to={language === "en" ? "/" : `/${language}`}>
            <img src={Logo} alt="Logo" />
          </NavLink>
          <div className="titles__block">
            <HeaderNav>
              <LayoutGroup>
                <motion.ul className="nav__ul">
                  {createMenu(titles, currentRoute)}
                </motion.ul>
              </LayoutGroup>
            </HeaderNav>
            <div className="buttons_block">
              <LangMenu
                name="lang"
                id="1"
                onChange={changeLanguage}
                value={language}
              >
                <option className="text-black" value="en">
                  EN
                </option>
                <option className="text-black" value="de">
                  DE
                </option>
                <option className="text-black" value="fr">
                  FR
                </option>
              </LangMenu>
              <NavLink
                to={generateLink("/auth/login", language)}
                className="header__buttons"
              >
                {t("header.logIn")}
              </NavLink>
            </div>
          </div>
        </HeaderContent>
      </HeaderContainer>
    </HeaderBlock>
  );
};
